import { UserManager } from 'oidc-client'

class ApplicationUserManager extends UserManager {
  constructor () {
    super({
      authority: '',
      client_id: 'afadminjs',
      redirect_uri: 'https://xxx/callback',
      response_type: 'id_token token',
      scope: 'openid profile roles af.core.api',
      post_logout_redirect_uri: 'https://xxx'
    })
  }

  async login () {
    await this.signinRedirect()
    return this.getUser()
  }

  async logout () {
    return this.signoutRedirect()
  }
}

const applicationUserManager = new ApplicationUserManager()
export { applicationUserManager as default }
